/* eslint max-len:0 */
import React, { Component } from 'react';

class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.onCheckBoxClick = this.onCheckBoxClick.bind(this);
    this.dispatch = props.dispatch;
    this.state = {
      id: props.id,
      checked: props.checked || false,
      callBackAction: props.callBackAction,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.updateCheckedStatus(this.props.checked);
    }
  }

  onCheckBoxClick() {
    this.setState(prevState => ({
      checked: !prevState.checked,
    }), () => {
      if (this.state.callBackAction) {
        this.state.callBackAction({
          id: this.props.id,
          checked: this.state.checked,
        });
      }
    });
  }

  updateCheckedStatus = (checkedStatus) => {
    this.setState({ checked: checkedStatus });
  };

  render() {
    const { iconType = 'round', id } = this.props;
    const iconState = {
      round: {
        unchecked: (
          <i
            className="td-icon icon-round-cross tick-box"
            role="checkbox"
            tabIndex="0"
            aria-checked="false"
          />
        ),
        checked: (
          <i
            className="td-icon icon-round-cross tick-box-ticked"
            role="checkbox"
            tabIndex="0"
            aria-checked="true"
          />
        ),
      },
      tick: {
        unchecked: (
          <svg
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className="tick-box"
            onClick={this.onCheckBoxClick}
          >
            <g id="Landing" fill="none" fillRule="evenodd">
              <g>
                <rect id="rectUnchecked" strokeWidth="2" x="1" y="1" width="18" height="18" rx="2" />
              </g>
            </g>
          </svg>
        ),
        checked: (
          <svg
            viewBox="0 0 22 22"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className="tick-box-ticked"
            onClick={this.onCheckBoxClick}
          >
            <defs>
              <rect id="path-1" x="0" y="0" width="22" height="22" rx="2" />
            </defs>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g className="Tick-Box-with-Tick">
                <g id="Rectangle">
                  <rect x="1" y="1" width="20" height="20" rx="2" />
                </g>
                <path
                  d="M17.9326923,6.55729167 C17.9775643,6.6475699 18,6.71527755 18,6.76041667 C18,6.80555578 17.9775643,6.87326344 17.9326923,6.96354167 L9.55288462,17.796875 C9.41826856,17.9322923 9.31730803,18 9.25,18 C9.13781995,18 9.02564159,17.943577 8.91346154,17.8307292 L4.16826923,13.2265625 L4.06730769,13.125 C4.02243567,13.0347218 4,12.9670141 4,12.921875 C4,12.8993054 4.02243567,12.8428824 4.06730769,12.7526042 L4.13461538,12.6848958 C4.76282365,12.0078091 5.25640846,11.4887171 5.61538462,11.1276042 C5.75000067,10.9921868 5.83974337,10.9244792 5.88461538,10.9244792 C5.97435942,10.9244792 6.08653779,10.9921868 6.22115385,11.1276042 L8.91346154,13.7682292 L15.6442308,5.06770833 C15.6891028,5.02256922 15.7564098,5 15.8461538,5 C15.9134619,5 15.9919867,5.02256922 16.0817308,5.06770833 L17.9326923,6.55729167 Z"
                  id="icon-checkmark"
                  fill="#FFFFFF"
                />
              </g>
            </g>
          </svg>
        ),
      },
    };
    return (
      <div className={`checkboxes ${iconType}`}>
        <button
          className="checkbox-wrapper"
          onClick={this.onCheckBoxClick}
          role="checkbox"
          tabIndex="0"
          aria-checked
          id={id}
        >
          {!this.state.checked ?
            iconState[iconType].unchecked
            :
            iconState[iconType].checked
          }
        </button>
      </div>
    );
  }
}

export default CheckBox;
